import { useQuery } from "react-query";
import { catalogApi, type CatalogSettings } from "@/lib/api/catalog";

export const CATALOG_SETTINGS_QUERY_KEY = ["catalog", "settings"] as const;

export function useCatalogSettings(options?: { enabled?: boolean }) {
  return useQuery<CatalogSettings>(
    CATALOG_SETTINGS_QUERY_KEY,
    () => catalogApi.getCatalogSettings(),
    {
      staleTime: 60 * 60 * 1000,
      enabled: options?.enabled ?? true,
    }
  );
}
